import { css } from "styled-components";

import { redundantCssFromKebab } from "./redundant-css";

// to style UiMarkdown and UiTextBlock consistently
export function getTextSizeCSS(textSize?: string): ReturnType<typeof css> {
    if (!textSize) {
        return css``;
    }
    return textSize === "Large"
        ? css`
              ${redundantCssFromKebab("font-size", `${fontSizes.lg}`)}
              ${redundantCssFromKebab("line-height", "1.75")}
          `
        : css`
              ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
          `;
}

// base rem size is 16px, trello sets `md` in the body
export const fontSizes = {
    xxs: "0.75rem", // 12px
    xs: "0.875rem", // 14px
    sm: "1rem", // 16px
    md: "1.25rem", // 20px
    lg: "1.5rem", // 24px
    xl: "2rem", // 32px
    xxl: "2.25rem" // 36px
};
